import styled from "styled-components";
import { Column } from "uikit";

const Root = styled(Column)`
	width: 142px;
`;

export default Root;
